import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';

import { LocationVarKey } from '@swivl-mono/types';
import {
  WorksheetColumn,
  WorksheetLayout,
  WorksheetRow,
} from '../../../Components/Worksheets/Layout/Worksheet.Layout.Components';
import { WorksheetComponent, WorksheetComponentType } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponent.Component';

export default function LocationSubpageHours() {
  const page = usePropertiesGetLocationIds();

  return (
    <WorksheetLayout>
        <h4>Hours</h4>
     <WorksheetRow>
        <WorksheetColumn>
          <WorksheetComponent
            componentType={WorksheetComponentType.MULTI_LINE}
            {...page}
            label="Location Hours"
            keyName={LocationVarKey.OfficeHours}
          />
          <WorksheetComponent
          componentType={WorksheetComponentType.MULTI_LINE}
          {...page}
          label="Access Hours"
          keyName={LocationVarKey.AccessHours}
          />
          <WorksheetComponent
          componentType={WorksheetComponentType.MULTI_LINE}
          {...page}
          label="Call Center Hours"
          keyName={LocationVarKey.CallCenterHours}
          />
        </WorksheetColumn>

     
      </WorksheetRow>
    </WorksheetLayout>
  );
}
